"use strict"

function scrollWindow(id, speed) {
  var page = $("html, body");

  var header = 0;

  page.on("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove", function () {
    page.stop();
  });

  page.animate({scrollTop: $(id).offset().top - header}, speed, function () {
    page.off("scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove");
  });

}

$(function() {
  $('.js-scroll').on('click', function(e){
    e.preventDefault();

    if($(this).data('is-tab')){
      var href = $(this).data('scroll-id');
      $('[data-toggle="tab"][href$="'+href+'"]').trigger('click');
    }
    scrollWindow($(this).data('scroll-id'));
  });
});


$(function() {
  $('.js-map').click(function() {
    $(this).find('iframe').toggleClass('scroll-off');
  });
  $('.js-map').on("mouseleave", function() {

    $(this).find('iframe').addClass('scroll-off');
  });
});




$(function() {
  var d = new Date();
  $('.js-actual-year').append(d.getFullYear());
});

$(function() {

  $('[data-toggle="tab"]').on('click', function(event) {
    event.preventDefault();
    var tabActiveClass = 'tab__item--is--active';
    if($(this).hasClass('lang-tab__link')){

      tabActiveClass = 'lang-tab__item--is--active';
    }

    $(this).parent().siblings().children().attr('aria-selected', 'false');
    $(this).attr('aria-selected', 'true');

    $(this).parent().siblings().removeClass(tabActiveClass);
    $(this).parent().addClass(tabActiveClass);
    var tab = $(this).attr('href');

    $(this).parent().parent().parent().siblings().children().not(tab).removeClass('tab__pane--is--active');
    $(tab).addClass('tab__pane--is--active');
  });

});



$(function(){

  $('[data-input-quantity="plus"]').on('click', function(e){

    /*e.preventDefault();*/
    getElementInputQuantity($(this)).val(doArithmeticInputQuantity(getValueInputQuantity($(this)), 'plus')).change();

  });

   $('.input-quantity__input').keypress(function(e){
      if(e.keyCode === 13){
         e.preventDefault();
         $('#'+$(this).data('form')).submit();
      }
  });

  $('[data-input-quantity="minus"]').on('click', function(e) {

    /*e.preventDefault();*/
    getElementInputQuantity($(this)).val(doArithmeticInputQuantity(getValueInputQuantity($(this)), 'minus')).change();

  });

  function getValueInputQuantity(_this){
    return parseInt((getElementInputQuantity(_this)).val());
  }

  function getElementInputQuantity(_this){
    return _this.siblings('input');
  }

  function plusOne(number){
    return number = number + 1;
  }

  function minusOne(number){
    return number = number - 1;
  }

  function doArithmeticInputQuantity(number, operation){

    if(isNaN(number)){
      return 1;
    }else{
      if (operation === 'plus') {
        if(number >= 1){
          return plusOne(number);
        }else{
          return 1;
        }
      }else if(operation === 'minus'){
        if(number > 1){
          return minusOne(number);
        }else{
          return 1;
        }
      }else{
        return 1;
      }
    }
  }

});






$(function() {
  var myLazyLoad = new LazyLoad({
    elements_selector: '.js-lazy',
    class_loaded: 'is-lazy--load',
    callback_set: function (e) {
      picturefill({ reevaluate: true });
    },
    callback_load: function(e){
      $(e).parent().siblings().children().attr('srcset', $(e).parent().siblings().children().data('srcset'));
    }
  });
});





$(function() {
  $(".js-cart-box-click").click(function(){
    event.preventDefault();
    toggleCartBox($(this), $(this).find('.js-cart-checkbox').prop('checked'));
  });
});


function toggleCartBox(target, isCartBoxChecked){
  if(!isCartBoxChecked){
    target.parent().find('.cart-box__toggle').slideDown();
    target.find('.js-cart-box-icon').css('transform', 'rotateZ(-180deg)');
    target.find('.js-cart-checkbox').prop('checked', true);
  }else{
    target.parent().find('.cart-box__toggle').slideUp();
    target.find('.js-cart-box-icon').css('transform', 'rotateZ(0)');
    target.find('.js-cart-checkbox').prop('checked', false);
  }
}



$(function() {


  var data =  $('.cart-ship__list').find('input[type="radio"]:checked').data('payments') + '';

  setPaymentShow(data.split(','));

  $('.cart-ship__list').on('click', 'label', function(event) {

    $('.cart-payment__list').each(function(index, el) {

      $(el).find('input[type="radio"]').parent().hide();
      $(el).find('input[type="radio"]').prop('checked', false);
    });

    data = $(this).siblings('input').data('payments') + '';

    setPaymentShow(data.split(','));


  });

});

function setPaymentShowDefault(){
  $('.js-cart-radio-shipping-default').show();
}
function setPaymentHideDefault(){
  $('.js-cart-radio-shipping-default').hide();
}
function setPaymentShow(data){

  $('#checkout-payment-'+data[0]).parent().show();
  $('#checkout-payment-'+data[1]).parent().show();
  $('#checkout-payment-'+data[2]).parent().show();
  $('#checkout-payment-'+data[3]).parent().show();

  if(data == 'undefined'){
    setPaymentShowDefault();
  }else{
    setPaymentHideDefault();
  }
}


function setTotalPaymentShip(price){

  $('.js-price-ship').text(price);
  setTotalPaymentPay('');

}

function setTotalPaymentPay(price){
  $('.js-price-payment').text(price);
}


function detectIE() {
  var ua = window.navigator.userAgent;


  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    /* IE 10 or older => return version number*/
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    /* IE 11 => return version number */
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  /* other browser */
  return false;
}


function parserInstagramData(data){
  var dp = new DOMParser();
  var doc = dp.parseFromString(data, "text/html");
  var scs = Array.from(doc.querySelectorAll('script'));
  var sharedDataRawText;

  $(scs).each(function() {
    if ($(this).children().length < 1 && $.trim($(this).text()).length != '') {
      var text = $(this).text();
      if (text.match(/^window._sharedData/) != null) {
        sharedDataRawText = JSON.parse(text.replace('window._sharedData = ', '').slice(0, -1));
      }
    }
  });

  return sharedDataRawText;
}

function downLoadInstagramData(username) {
  return new Promise(function (resolve, reject) {
    $.ajax({
      url: 'https://www.instagram.com/' + username + '/',

      success: function (result) {
        resolve(result);
      },
      error: function (err) {
        reject(err);
      }
    });

  });

}

function appendInstagramData(userInstagram){

  if (userInstagram) {
    for (var i in userInstagram.edge_owner_to_timeline_media.edges) {
      var img = '<div class="instagram-content__item"><a href="https://www.instagram.com/p/' + userInstagram.edge_owner_to_timeline_media.edges[i].node.shortcode + '" class="instagram-content__link" target="_blank">' + '<img src="' + userInstagram.edge_owner_to_timeline_media.edges[i].node.thumbnail_src + '" class="instafeed-img"> </a></div>';
      $('.js-instagram-content').append('<div class="swiper-slide instagram-content__img">' + img + '</div>');
    }
  }
}

function onlyOneInstagramData(rawData){
  return rawData.entry_data.ProfilePage[0].graphql.user;
}

function initInstagramCarousel(targetWrapper){
  var swiper = new Swiper(targetWrapper, {
    direction: 'horizontal',
    loop: true,
    slidesPerView: 'auto',
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
}


$(function() {
  /*var mqSroll = '77em';

  if (!Modernizr.mq('(min-width: ' + mqSroll + ')')) {

    var prevScrollpos = window.pageYOffset;
    window.onscroll = function() {
      var currentScrollPos = window.pageYOffset;
      if (prevScrollpos > currentScrollPos) {
        $('.header').css('top', '0');
      } else {
        $('.header').css('top', '-6rem');
      }
      prevScrollpos = currentScrollPos;
    }

  }*/

});


